import * as action from './modalAction'
import { default as actionType } from './modalActionType'
import { default as reducer } from './modalReducer'

export const MODAL = {
  action,
  actionType,
  reducer
}

export default action
